export default {
  usable: {
    value: 6,
    name: '可使用',
  },
  valid: {
    value: 1,
    name: '已开卡且可使用',
  },
  notUsed: {
    value: 2,
    name: '未开卡',
  },
  reviewing: {
    value: 3,
    name: '审核中',
  },
  stopped: {
    value: 7,
    name: '停卡中',
  },
  expired: {
    value: 4,
    name: '已过期',
  },
  exhausted: {
    value: 5,
    name: '已用完',
  },
};
